import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { State } from "../../store";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";
import BasketNavButton from "../../../features/NavBar/features/BasketNavButton";

const LimitedTicketColorPage: React.FC = () => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration.componentList);
  const messageColors = useSelector((state: State) => state.config.configuration.message_tickets);

  const { colorGroup, requestGetColorGroups } = useTickets();

  useEffect(() => {
    requestGetColorGroups();
  }, []);

  return (
    <React.Fragment>
      <div className="container">


        {colorGroup && (
          <React.Fragment>
            {colorGroup.map((item, index) => (
              <div key={index}>
                <LimitedTicketBlock item={item} sortType="colorGroup" />
              </div>
            ))}
            <BasketNavButton/>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default LimitedTicketColorPage;
